module.exports = "<cm-notification-factory></cm-notification-factory>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 4